import { Component, Input } from '@angular/core';

// Minor words that should stay lowercase in title case (unless first word)
const MINOR_WORDS = new Set(['a', 'an', 'the', 'and', 'but', 'or', 'for',
  'nor', 'on', 'at', 'to', 'by', 'in', 'of', 'up', 'as', 'is', 'it']);

@Component({
  selector: 'app-section-wrapper',
  standalone: false,
  templateUrl: './section-wrapper.component.html',
  styleUrl: './section-wrapper.component.scss',
})
export class SectionWrapperComponent {
  @Input() title: string = '';
  @Input() fullWidth: boolean = false;
  @Input() tightSpacing: boolean = false;

  /** Normalise an all-caps string to title case (e.g. "SHOP BY CATEGORY" → "Shop by Category"). */
  private toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .split(' ')
      .map((word, index) =>
        index === 0 || !MINOR_WORDS.has(word)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word
      )
      .join(' ');
  }

  private get normalisedTitle(): string {
    return this.toTitleCase(this.title);
  }

  getFirstPart(): string {
    const t = this.normalisedTitle;
    if (t === 'Calibration Ready Test Weights') {
      return 'Calibration Ready';
    }
    const words = t.split(' ');
    const midPoint = Math.ceil(words.length / 2);
    return words.slice(0, midPoint).join(' ');
  }

  getSecondPart(): string {
    const t = this.normalisedTitle;
    if (t === 'Calibration Ready Test Weights') {
      return 'Test Weights';
    }
    const words = t.split(' ');
    const midPoint = Math.ceil(words.length / 2);
    return words.slice(midPoint).join(' ');
  }
}
